import React, {useState, useEffect} from "react";
import { Layout, Button, Typography } from "antd";

import Sidebar from "../Sidebar/index";
import HorizontalDefault from "../Topbar/HorizontalDefault/index";
import HorizontalDark from "../Topbar/HorizontalDark/index";
import InsideHeader from "../Topbar/InsideHeader/index";
import AboveHeader from "../Topbar/AboveHeader/index";
import BelowHeader from "../Topbar/BelowHeader/index";

import Topbar from "../Topbar/index";
import { footerText } from "util/config";
import App from "routes/index";
import Customizer from "containers/Customizer";
import { useSelector } from "react-redux";
import {useHistory, Link} from "react-router-dom";
import { logDailyActivity } from "../../services/activityLogger";

import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE
} from "../../constants/ThemeSetting";
import NoHeaderNotification from "../Topbar/NoHeaderNotification/index";
import { useRouteMatch } from "react-router-dom";
import moment from "moment";
import './style.less';
import MobileMenu from "./MobileMenu";
import KycVerificationNotifications from "../../components/KycVerificationNotifications";
import CoordinatorAlerts from "../../components/CoordinatorAlerts";


const year=moment().format("YYYY");
const { Content, Footer } = Layout;
// const user_role = localStorage.getItem('user_role') ? localStorage.getItem('user_role') : ""
const {Text, Paragraph} = Typography;
const MainApp = () => {
  const history = useHistory();
  const { width, navStyle } = useSelector(({ settings }) => settings);
  const [user_role, setUserRole] = useState(localStorage.getItem('user_role') ? localStorage.getItem('user_role') : "")
  const match = useRouteMatch();

  // Log daily user activity on first interaction of the day
  useEffect(() => {
    logDailyActivity();
  }, []);

  // console.log(user_role,'userrrrrrrrrrrrrrrrrrrrrrrr')
  const getContainerClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DARK_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_BELOW_HEADER:
        return "gx-container-wrap";
      case NAV_STYLE_ABOVE_HEADER:
        return "gx-container-wrap";
      default:
        return '';
    }
  };
  const getNavStyles = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return <HorizontalDefault />;
      case NAV_STYLE_DARK_HORIZONTAL:
        return <HorizontalDark />;
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return <InsideHeader />;
      case NAV_STYLE_ABOVE_HEADER:
        return <AboveHeader />;
      case NAV_STYLE_BELOW_HEADER:
        return <BelowHeader />;
      case NAV_STYLE_FIXED:
        // return <Topbar />;
        return null
      case NAV_STYLE_DRAWER:
        return null
        // return <Topbar />;
      case NAV_STYLE_MINI_SIDEBAR:
        return null
        // return <Topbar />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <NoHeaderNotification />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <NoHeaderNotification />;
      default:
        return null;
    }
  };
  const getNavStyles2 = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return <HorizontalDefault />;
      case NAV_STYLE_DARK_HORIZONTAL:
        return <HorizontalDark />;
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return <InsideHeader />;
      case NAV_STYLE_ABOVE_HEADER:
        return <AboveHeader />;
      case NAV_STYLE_BELOW_HEADER:
        return <BelowHeader />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <NoHeaderNotification />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <NoHeaderNotification />;
      default:
        return null;
    }
  };

  const getSidebar = (navStyle, width) => {
    if (width < TAB_SIZE) {
      return <Sidebar />;
    }
    switch (navStyle) {
      case NAV_STYLE_FIXED:
        return <Sidebar />;
      case NAV_STYLE_DRAWER:
        return <Sidebar />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Sidebar />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <Sidebar />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <Sidebar />;
      default:
        return null;
    }
  };

        return (
          <Layout className="gx-app-layout">
            <MobileMenu />
            {getSidebar(navStyle, width)}
            <Layout>
              {user_role == 'accounts_user' || user_role == 'finance_user' || user_role == 'project_manager' || user_role == 'client_invoicer'
              || user_role === 'coordinator' || user_role === 'data_entry' || user_role === 'client_user'  || user_role === 'client_manager' || user_role === 'verify_scheduler' 
              || user_role === 'client_admin' || user_role === 'qc' || user_role === 'customer_connect' || user_role === 'payable_partner_user' ? getNavStyles2(navStyle) : getNavStyles(navStyle)}
              <Content className={`gx-layout-content ${getContainerClass(navStyle)} `}>
                <App match={match} />
                <Footer>
                  <p>
                    {footerText}{year}  version - <code>v{global.appVersion}</code>
                  </p>
                </Footer>
              </Content>
            </Layout>
            <KycVerificationNotifications />
            <CoordinatorAlerts />
            {/* <Customizer/> */}
          </Layout>
        );
   
};
export default MainApp;
